import { mapGetters, mapMutations } from "vuex";

export default {
  computed: {
    isScreenShareFull() {
      return (
        this.is_screen_share_fullscreen ||
        this.is_screen_share_browser_fullscreen
      );
    },
    isScreenShareSameRoom() {
      return this.cur_channel_data.room_id === this.cur_room_data.room_id;
    },
    isNoTextChannel() {
      return (
        !this.cur_text_channel_data ||
        Object.keys(this.cur_text_channel_data).length === 0
      );
    },
    ifScreenShareDom() {
      return this.cur_channel_has_screen_share && !this.cur_channel_data.refuse_user_audio;
    },
    isMe() {
      return this.screen_sharing_info.is_me;
    },
    showScreenShareDom() {
      return (
        this.isScreenShareSameRoom &&
        this.isNoTextChannel &&
        this.ifScreenShareDom
      );
    },
    ...mapGetters([
      "is_show_screen_sharing",
      "screen_share_user_list",
      "is_show_screen_share_menu",
      "is_screen_share_fullscreen",
      "is_screen_share_browser_fullscreen",
      "screen_sharing_info",
      "cur_channel_has_screen_share",
      "is_focusing_mini_input",
    ]),
  },
  methods: {
    screenShareMouseEnter() {
      if (this.isScreenShareFull) return;
      this.SET_IS_SHOW_SCREEN_SHARE_MENU(true);
    },
    screenShareMouseLeave() {
      if (this.isScreenShareFull || this.is_focusing_mini_input) return;
      this.SET_IS_SHOW_SCREEN_SHARE_MENU(false);
    },
    screenShareMouseOver() {
      if (!this.isScreenShareFull) return;
      clearTimeout(this.hideScreenShareMenuTimeout);
      this.hideScreenShareMenuTimeout = setTimeout(() => {
        if (this.isScreenShareFull) {
          this.SET_IS_SHOW_SCREEN_SHARE_MENU(false);
        }
      }, 2000);
      this.SET_IS_SHOW_SCREEN_SHARE_MENU(true);
    },
    ...mapMutations([
      "SET_IS_SHOW_SCREEN_SHARE_MENU",
      "SET_IS_SCREEN_SHARE_FULLSCREEN",
      "SET_IS_SCREEN_SHARE_BROWSER_FULLSCREEN",
    ]),
  },
};
